import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  generateRecaptchaToken
} from "./chunk-W4XMZLKW.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/booking/claimOrder.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var validateOfflineOrderToken = (_0) => __async(void 0, [_0], function* ({ token }) {
  var _a;
  try {
    const data = yield fetchClient({
      url: "/validate-token",
      options: {
        method: "POST",
        body: JSON.stringify({ token })
      }
    });
    if (data.status !== "success") {
      throw new Error(((_a = data == null ? void 0 : data.error) == null ? void 0 : _a.message) || (data == null ? void 0 : data.message) || "Something went wrong");
    }
    return data;
  } catch (error) {
    throw new Exception({
      error,
      name: "validateOfflineOrderTokenException",
      context: { tags: { journey: "profile" }, extra: { token } }
    });
  }
});
var claimOfflineOrderAndUpdateUser = (body) => __async(void 0, null, function* () {
  try {
    const lang = getLocaleOnly(body.lang);
    const captcha = yield generateRecaptchaToken("claimTickets");
    const data = yield fetchClient({
      url: "/update-user-claim-order",
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({}, body), { captcha, lang }))
      }
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "claimOfflineOrderAndUpdateUserException",
      context: { tags: { journey: "profile" }, extra: __spreadProps(__spreadValues({}, body), { password: "__hidden__" }) }
    });
  }
});
var claimOfflineOrder = (token) => __async(void 0, null, function* () {
  try {
    const data = yield fetchClient({
      url: "/claim-order",
      options: {
        method: "POST",
        body: JSON.stringify({ token })
      }
    });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "claimOfflineOrderException",
      context: { tags: { journey: "profile" }, extra: { token } }
    });
  }
});

export {
  validateOfflineOrderToken,
  claimOfflineOrderAndUpdateUser,
  claimOfflineOrder
};
//# sourceMappingURL=chunk-KVUL37HD.mjs.map